module.exports = __webpack_public_path__ + "static/img/ggsc5.85d5839.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/ggsc5.gif
// module id = TuPh
// module chunks = 0